import type { State } from '../../types.tsx';

export const getActiveCustomFilterIds = (state: State): string[] =>
	state.ui.workFilters?.values.CUSTOM_FILTER ?? [];

export const isCustomFiltersActive = (state: State) => getActiveCustomFilterIds(state).length > 0;
